export default "__VITE_PUBLIC_ASSET__11133c2f__"